import { PageRoutePath } from 'src/App/routing'

import { FooterSection } from './types'

export const FOOTER_LINKS: FooterSection[] = [
	{
		title: 'Products',
		links: [
			{ heading: 'VoltNet', url: PageRoutePath.VoltNet },
			{ heading: 'VoltNow', url: PageRoutePath.VoltNow },
			{ heading: 'VoltPOS', url: PageRoutePath.VoltPos }
		]
	},
	{
		title: 'Company',
		links: [{ heading: 'About Us', url: PageRoutePath.AboutUs }]
	},
	{
		title: 'Support',
		links: [{ heading: 'Contact Us', url: PageRoutePath.ContactUs }]
	}
]
